export const POLICY = {
  name: '',
  id: 'new',
  is_active: false,
}

export default POLICY
